import { useState } from 'react';
import PhoneShell from '../components/shared/PhoneShell';
import BackHeader from '../components/shared/BackHeader';
import { maskStyle } from '../utils/icons';

const css = `
  .msum { padding: 4px 16px 14px; box-shadow: inset 0 -1px 0 rgba(255,255,255,.08); }
  .msum-line { display: flex; align-items: center; justify-content: space-between; gap: 10px; height: 26px; }
  .msum-team { font-size: 15px; color: #fff; }
  .msum-score { font-size: 15px; font-weight: 700; color: #fff; }
  .msum-ht { font-size: 13px; color: #9b9ab0; margin-top: 2px; }

  .mkt { box-shadow: inset 0 -1px 0 rgba(255,255,255,.06); }
  .mkt-head { width: 100%; display: flex; align-items: center; justify-content: space-between; height: 52px; padding: 0 16px; text-align: left; font-size: 15px; font-weight: 500; color: #fff; }
  .mkt-chev { width: 12px; height: 7px; background: #9b9ab0; transform: rotate(90deg); transition: transform .2s ease; flex: none; }
  .mkt.is-open .mkt-chev { transform: rotate(-90deg); }
  .mkt-body { display: none; padding: 0 16px 16px; }
  .mkt.is-open .mkt-body { display: block; }
  .mkt-pick { font-size: 14px; color: #9b9ab0; }
`;

const MATCH = { home: 'Kawasaki Frontale', away: 'Shanghai Port FC', hs: '3', as: '1', ht: '3:1 (3:0)' };

const MARKETS = [
  { name: 'Match Result', pick: 'W1', open: true },
  { name: 'Double Chance' },
  { name: 'Total Goals' },
  { name: 'Team 1 Total Goals' },
  { name: 'Team 2 Total Goals' },
  { name: 'Goals Handicap' },
  { name: 'Goals Handicap 3 Way' },
  { name: '1st Goal to Score' },
  { name: '2nd Goal to Score' },
  { name: 'Both Team to Score' },
  { name: 'Total Goals Odd/Even' },
];

function MarketAccordion({ market }) {
  const [open, setOpen] = useState(!!market.open);
  return (
    <section className={'mkt' + (open ? ' is-open' : '')}>
      <button className="mkt-head" onClick={() => setOpen(!open)}>
        <span>{market.name}</span>
        <span className="mkt-chev" style={maskStyle('ic-chevron')} />
      </button>
      <div className="mkt-body">
        <span className="mkt-pick">{market.pick || '—'}</span>
      </div>
    </section>
  );
}

export default function MatchResult() {
  return (
    <PhoneShell activeTab="sports">
      <style>{css}</style>
      <BackHeader title="Football" />
      <div className="msum">
        <div className="msum-line"><span className="msum-team">{MATCH.home}</span><span className="msum-score">{MATCH.hs}</span></div>
        <div className="msum-line"><span className="msum-team">{MATCH.away}</span><span className="msum-score">{MATCH.as}</span></div>
        <p className="msum-ht">{MATCH.ht}</p>
      </div>
      <div>
        {MARKETS.map((mk, i) => <MarketAccordion key={i} market={mk} />)}
      </div>
    </PhoneShell>
  );
}
